import { client as clientRoutes } from 'config/routes'

export const GOUSTO_ANYTIME_INTENT_URLS: Record<string, string> = {
  start_one_off_order: clientRoutes.menu,
  reactivate_subscription: `${clientRoutes.mySubscription}?view=resubscribe`,
}

export const getUrlForGoustoAnytimeIntent = (intent: string): string | undefined =>
  GOUSTO_ANYTIME_INTENT_URLS[intent]
